// Shared column template so the header row and every data row line up.
// Columns: drag handle · color · key · label · enabled · actions.
export const STAGE_ROW_GRID =
  'grid grid-cols-[24px_36px_minmax(50px,240px)_minmax(100px,1fr)_60px_72px] items-center gap-x-16';
